import React, { useEffect } from 'react'
import GSTC from './GSTC'
import { connect } from 'react-redux'
function App({ header, data, height, gantt }) {
  const config = {
    height: 50 + height * 100,
    list: {
      rows: gantt?.gantt.rows,
      columns: {
        data: header,
        resizer: {
          width: 10,
          dots: 8
        }
      },
      toggle: {
        display: false
      }
    },
    chart: {
      items: gantt?.gantt.items,
      time: {
        period: 'week'
      }
    }
  }

  let subs = []

  function onState(state) {
    state.update('config.chart.items.1', item1 => {
      item1.label = 'Gantt schedule timeline calendar'
      item1.time.end = item1.time.end + 2 * 24 * 60 * 60 * 1000
      return item1
    })
    subs.push(state.subscribe('config.chart.items', items => {}))
    subs.push(state.subscribe('config.list.rows', rows => {}))
  }

  useEffect(() => {
    return () => {
      subs.forEach(unsub => unsub())
    }
  })

  return <div>{gantt?.gantt ? <GSTC config={config} onState={onState} /> : null}</div>
}
const mapStateToProps = state => {
  return {
    gantt: state.appraisal.gantt
  }
}
export default connect(mapStateToProps)(App)
